<template>
	<v-dialog v-model="dialog" persistent max-width="800" scrollable content-class="rounded-xl">
		<template v-if="Object.keys(details)">
			<v-card>
				<v-card-title class="justify-space-between pb-0">
					<div class="font-size-13 secondary--text">Detail Transaksi</div>
					<v-btn small text class="px-0 mr-n4" @click="modalHide">
						<v-icon color="red">mdi-close</v-icon>
					</v-btn>
				</v-card-title>
				<v-card-text class="pt-3">
					<div class="d-block py-0 black--text">
						<v-row>
							<v-col cols="12" sm="5">
								<div class="d-flex flex-row justify-space-between text-subtitle-2 font-weight-bold mb-1">
									<span class="pr-3 d-block">No. Transaksi</span>
									<span class="darkgreen--text d-block">{{ details.trx_code }}</span>
								</div>
							</v-col>
							<v-col cols="2" v-if="!isMobile"></v-col>
							<v-col cols="12" sm="5">
								<div class="d-flex flex-row justify-space-between mb-2">
									<span sm="3" class="text-subtitle-2 py-0 font-weight-bold">Tanggal</span>
									<span sm="9" class="py-0">{{ formatDateText(details.trx_status_created_datetime, 'DD MMMM YYYY hh:mm:ss') }}</span>
								</div>
								<div class="d-flex flex-row justify-space-between mb-2">
									<span sm="3" class="text-subtitle-2 py-0 font-weight-bold"></span>
									<span sm="9" class="py-0">
										<v-chip
											color="green"
											outlined
										>{{ statusCaption(details.trx_status) }}</v-chip>
									</span>
								</div>
							</v-col>
						</v-row>

						<v-row>
							<v-col cols="12" sm="5">
								<v-row>
									<v-col cols="12" sm="12" class="text-subtitle-2 py-0 font-weight-bold">Alamat Pengiriman :</v-col>
									<v-col cols="12" sm="12" class="py-0 text-caption">{{ details.trx_store_address }}</v-col>
								</v-row>
							</v-col>
							<v-col cols="2" v-if="!isMobile"></v-col>
							<v-col cols="12" sm="5" v-if="details.trx_shipping_method == 'courier'">
								<div class="d-flex flex-row text-subtitle-2 font-weight-bold">
									<span class="pr-3">Tujuan Pengiriman :</span>
								</div>
								<div class="d-flex flex-row text-subtitle-2 font-weight-bold mt-1">
									<span class="pr-3">{{ details.trx_buyer_user_name }}</span>
								</div>
								<div class="text-caption pr-5">
									{{ details.user_address_detail }}, {{ details.user_address_subdistrict_name }}, {{ details.user_address_city_name }},	{{ details.user_address_province_name }},	{{ details.user_address_zipcode }} <br>
									{{ details.trx_buyer_user_mobilephone }}
								</div>
							</v-col>
							<v-col cols="12" sm="5" v-else>
								<div class="d-flex flex-row text-subtitle-2 font-weight-bold">
									<span class="pr-3">Pembeli :</span>
								</div>
								<div class="d-flex flex-row text-subtitle-2 font-weight-bold mt-1">
									<span class="pr-3">{{ details.trx_buyer_user_name }} ({{ details.trx_buyer_user_mobilephone }})</span>
								</div>
								<div class="d-flex mt-2 flex-row text-subtitle-2 font-weight-bold">
									<span class="pr-3">Tanggal Pengambilan :</span>
								</div>
								<div class="d-flex flex-row text-subtitle-2 font-weight-bold mt-1">
									<span class="pr-3">{{ details.trx_pick_up_date | tanggal }}</span>
								</div>
							</v-col>
						</v-row>

						<!-- <v-divider class="mb-5 my-5"></v-divider> -->

						<!-- detail pesanan -->
						<v-card elevation="0" outlined class="rounded-lg mt-5" style="border-color: #ddd;">
							<v-card-text>
								<v-simple-table>
									<template v-slot:default>
										<thead>
											<tr class="mb-2" v-if="!isMobile">
												<th class="text-left" width="40%">
													<div class="text-subtitle-2 font-weight-bold">Nama Produk</div>
												</th>
												<th class="text-center">
													<div class="text-subtitle-2 font-weight-bold">Jumlah</div>
												</th>
												<th class="text-center" width="15%">
													<div class="text-subtitle-2 font-weight-bold">Berat</div>
												</th>
												<th class="text-right" width="20%">
													<div class="text-subtitle-2 font-weight-bold">Harga Barang</div>
												</th>
												<th class="text-right" width="20%">
													<div class="text-subtitle-2 font-weight-bold">Subtotal</div>
												</th>
											</tr>
											<tr class="mb-2" v-else>
												<th class="text-left">
													<div class="text-subtitle-2 font-weight-bold">Info Produk</div>
												</th>
											</tr>
										</thead>
										<tbody>
											<template v-if="details.trx_detail.length > 0">
												<template v-if="!isMobile">
													<template v-for="(item, idx) in details.trx_detail">
														<tr :key="idx">
															<td class="text-left">
																<span class="d-block text-subtitle-2 font-weight-bold">{{ item.trx_detail_product_name }}</span>
															</td>
															<td class="text-center">{{ item.trx_detail_quantity }}</td>
															<td class="text-center">{{ item.trx_detail_product_weight | toKg }}</td>
															<td class="text-right">{{ item.trx_detail_product_price | toRupiah }}</td>
															<td class="text-right">{{ (item.trx_detail_product_price * item.trx_detail_quantity) | toRupiah }}</td>
														</tr>
													</template>
												</template>

												<template v-else>
													<template v-for="(item, idx) in details.trx_detail">
														<tr :key="idx">
															<td class="text-left">
																<span class="d-block text-subtitle-2 font-weight-bold mt-2">{{ item.trx_detail_product_name }}</span>
																<span class="d-block text-caption font-weight-normal">Jumlah : <strong class="text-subtitle-2">{{ item.trx_detail_quantity }}</strong></span>
																<span class="d-block text-caption font-weight-normal">Berat : <strong class="text-subtitle-2">{{ item.trx_detail_product_weight | toKg }}</strong></span>
																<span class="d-block text-caption font-weight-normal">Harga : <strong class="text-subtitle-2">{{ item.trx_detail_product_price | toRupiah }}</strong></span>
																<v-divider class="my-3"></v-divider>
																<span class="d-block text-subtitle-2 font-weight-normal text-right">Subtotal :</span>
																<span class="d-block text-subtitle-2 font-weight-normal text-right mb-2"><strong>{{ (item.trx_detail_product_price * item.trx_detail_quantity) | toRupiah }}</strong></span>
															</td>
														</tr>
													</template>
												</template>
											</template>
											<template v-else>
												<tr>
													<td :colspan="(isMobile) ? 1 : 5" class="pa-5 text-center">
														Tidak ada details barang yang dapat ditampilak.
													</td>
												</tr>
											</template>
										</tbody>
										<tfoot>
											<tr>
												<th :colspan="(isMobile) ? 1 : 5" class="text-right py-0">
													<v-divider class="my-2"></v-divider>
													<div class="d-flex align-center justify-end black--text" :class="(isMobile) ? 'flex-column' : 'flex-row'">
														<span class="text-subtitle-1" :class="(isMobile) ? 'text-right d-flex align-self-end' : 'd-block font-weight-bold pr-5 mr-5'">Total Harga</span>
														<span class="text-subtitle-1 font-weight-bold text-right" :class="(isMobile) ? 'text-right d-flex align-self-end' : 'd-block pl-5 ml-5'">{{ details.trx_price_total | toRupiah }}</span>
													</div>
													<!-- <v-divider class="my-2"></v-divider> -->
												</th>
											</tr>
										</tfoot>
									</template>
								</v-simple-table>
							</v-card-text>
						</v-card>

						<!-- pengiriman -->
						<modalCourier ref="modalCourier" @action="selectCour" :showPickupStore="false"></modalCourier>
						<div class="text-body-2 mb-2 mt-5">
							<v-card elevation="0" outlined class="rounded-lg" style="border-color: #ddd;">
								<v-card-text>
									<v-row class="justify-space-between align-center">
										<v-col class="py-0"><h4>Opsi Pengiriman :</h4></v-col>
										<v-col class="py-0 d-flex justify-end">
											<div v-if="Object.keys(selectedCour).length > 0" class="my-auto text-sm-center">
												<v-btn outlined color="indigo" class="font-weight-bold text-capitalize" @click="openModalCour">Ganti Pengiriman</v-btn>
											</div>
											<div v-else class="my-auto text-sm-center">
												<v-btn outlined color="primary" class="font-weight-bold text-capitalize" @click="openModalCour">Pilih Pengiriman</v-btn>
											</div>
										</v-col>
									</v-row>
								</v-card-text>
								<v-card-text style="border-top: 1px solid #999;">
									<!-- <pre>{{ selectedCour }}</pre> -->
									<v-row class="justify-end align-center">
										<template v-if="typeof selectedCour == 'object' && Object.values(selectedCour).length > 0">
											<v-col cols="12" sm="9" md="9" class="pr-md-0 py-0">
												<div class="d-flex flex-row align-center">
													<div class="my-auto pr-5">
														<v-img width="80" :src="'/assets/courier/'+selectedCour.code.toLowerCase()+'.svg'"></v-img>
													</div>
													<div class="px-2 font-weight-bold">{{selectedCour.description}}</div>
													<div class="px-2 text-uppercase">{{selectedCour.code}} {{selectedCour.service}}</div>
													<div class="px-2 grey--text text--darken-1">{{selectedCour.etd}}</div>
												</div>
											</v-col>
											<v-col sm="3" md="3" class="my-auto text-body-2 text-right">
												<div class="font-weight-bold">Rp {{selectedCour.cost ? selectedCour.cost : 0 | toNumber}}</div>
											</v-col>
										</template>
										
										<template v-else>
											<v-col cols="12" sm="12" md="12" class="pr-md-0 py-0 my-auto text-center">
												Silahkan pilih pengiriman terlebih dahulu
											</v-col>
										</template>
									</v-row>
									<!-- <v-alert v-model="responseError.courier" v-if="responseError.courier" dense color="red lighten-1" class="white--text" dismissible> {{responseError.courier.message}} </v-alert> -->
								</v-card-text>
							</v-card>
						</div>

						<!-- total transaksi -->
						<v-card elevation="0" outlined class="rounded-lg mt-5" style="border-color: #ddd;">
							<v-card-text>
								<div class="d-flex flex-row justify-space-between">
									<span sm="3" class="text-subtitle-1 py-0 font-weight-bold">Total Transaksi</span>
									<span sm="9" class="text-subtitle-1 font-weight-bold primary--text py-0">{{ (parseFloat(selectedCour.cost) + parseFloat(details.trx_price_total)) | toRupiah }}</span>
								</div>
							</v-card-text>
						</v-card>
					</div>
					<!-- <pre>{{ details }}</pre> -->
				</v-card-text>
				<v-card-actions class="justify-center">
					<v-col cols="4">
						<v-btn depressed outlined block color="primary" class="white--text rounded-xl text-capitalize" :loading="btnLoadingProses" :disabled="btnLoadingProses" @click="modalHide">
							<v-icon small>mdi-close</v-icon>
							<span class="pl-2">Tutup</span>
						</v-btn>
					</v-col>
				</v-card-actions>
			</v-card>
		</template>
	</v-dialog>
</template>

<script>
// import { mapActions } from 'vuex'
import moment from 'moment'
import modalCourier from './ModalCourier'

export default {
	components: {
		modalCourier
	},
	data () {
		return {
			dialog: false,
			searchDate: false,
			btnLoadingProses: false,
			isMobile: false,
			grandWeightTotal: 0,
			selectedCour: {},
			params: {
				name: {
					type:'string',
					field:'stockist_name',
					comparison: '<>',
					value:''
				},
				code: {
					type:'string',
					field:'stockist_member_network_code',
					comparison: '<>',
					value:''
				},
				province: {
					type:'string',
					field:'stockist_province_id',
					comparison: '<>',
					value:''
				},
				city: {
					type:'string',
					field:'stockist_city_id',
					comparison: '<>',
					value:''
				},
			},
		}
	},
	computed:{
		// ...mapState('opsi', ['provinces', 'cities']),
	},
	props: {
		data: Object,
		details: Object
	},
	methods :{
		// ...mapActions('opsi', ['getProvince', 'getCity']),

		formatDateText(params, format) {
			let dates = (params) ? new Date(params) : null
			return (dates) ? moment(dates).format(format) : null
		},

		statusCaption(status) {
      if (status === 'paid') return 'Sudah Dibayar'
      else if (status === 'processed') return 'Siap Diproses'
      else if (status === 'on_delivery') return 'Dalam Pengiriman'
      else if (status === 'completed') return 'Pesanan Selesai'
      else if (status === 'cancel') return 'Dibatalkan'
    },

		onResize() {
			if (window.innerWidth < 769)
				this.isMobile = true
			else
				this.isMobile = false
		},

		changeProvince() {
			this.getCity({ province_id: this.params.province.value	})
			this.params.city.value = ''
		},
		modalShow() {
			this.dialog = true
			// this.getProvince()
		},
		modalHide() {
			this.dialog = false
			this.btnLoadingProses = false
			this.$emit('action', this.params)
		},
		reset() {
			this.params.name.value = ''
			this.params.code.value = ''
			this.params.province.value = ''
			this.params.city.value = ''
		},
		async cari() {
			this.btnLoadingProses = await true
			await this.$emit('action', this.params)
		},
		openModalCour(){
			this.$refs.modalCourier.modalShow(this.selectedCour);
			this.responseError.courier = '';
		},
		selectCour(cour){
			this.selectedCour = cour
		},
		setSelectedCour() {
			this.selectedCour = {
				code: 'jne',
				name: 'Jalur Nugraha Ekakurir (JNE)',
				service: 'OKE',
				description: 'Ongkos Kirim Ekonomis',
				cost: 39000,
				etd: '3-4 Hari',
				note: ''
			}
		}
	},
	mounted() {
		if (Object.keys(this.details).length > 0) {
			this.grandWeightTotal = this.details.trx_detail.reduce((accumulator, current) => parseFloat(accumulator) + parseFloat(current.trx_detail_product_weight * current.trx_detail_quantity), 0)
			this.setSelectedCour()
		}
	},
};
</script>